<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ $route.meta.navtabTitle }}
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm"
        />
      </div>
    </div>

    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterForm"
          :model="filter"
          :inline="true"
          class="c-form c-condition__form"
          label-width="90px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filter.xmmc"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!pendingGeneration"
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="报告状态"
                prop="bgzt"
              >
                <el-select
                  v-model="filter.bgzt"
                  clearable
                >
                  <el-option
                    label="历史待签章"
                    value="DQZ"
                  />
                  <el-option
                    label="已完成"
                    value="YWC"
                  />
                  <el-option
                    label="已失效"
                    value="YZF"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!pendingGeneration"
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="有效状态"
                prop="yxzt"
              >
                <el-select
                  v-model="filter.yxzt"
                  clearable
                >
                  <el-option
                    label="当前有效"
                    value="Y"
                  />
                  <el-option
                    label="历史失效"
                    value="N"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>

    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane :label="pendingGeneration ? '待生成项目' : '报告记录'">
          <k-table
            height="100%"
            :table-column="columns"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="changePageSize"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openNavTab({ name: 'jxxfPgxmDetail', params: { id: scope.row.xmId } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #bgbh="scope">
              <el-link
                v-if="scope.row.dzWjId || scope.row.yqzWjId"
                type="primary"
                @click="downloadPreferred(scope.row)"
              >
                {{ scope.row.bgbh }}
              </el-link>
              <span v-else>{{ scope.row.bgbh || '-' }}</span>
            </template>
            <template #status="scope">
              <el-tag
                size="small"
                :type="scope.row.bgzt === 'YWC' ? 'success' : scope.row.bgzt === 'YZF' ? 'info' : 'warning'"
              >
                {{ statusText(scope.row) }}
              </el-tag>
            </template>
            <el-table-column
              label="操作"
              width="280"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <report-preview-button
                  v-if="pendingGeneration"
                  :project-id="scope.row.xmId"
                  :project-name="scope.row.xmmc"
                  @report-generated="handleReportGenerated"
                />
                <template v-else>
                  <k-button
                    v-if="scope.row.dzWjId || scope.row.yqzWjId"
                    btn-text="下载报告"
                    :auth-type="false"
                    type="primary"
                    plain
                    @click="downloadPreferred(scope.row)"
                  />
                  <k-button
                    v-if="scope.row.yxzt === 'Y' && ['DQZ', 'YWC'].includes(scope.row.bgzt)"
                    btn-text="重新评估"
                    :auth-type="true"
                    type="warning"
                    plain
                    @click="reevaluate(scope.row)"
                  />
                </template>
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ReportPreviewButton from './ReportPreviewButton.vue';
import { pgxmManageService } from '../pgxm/pgxm.service';
import { pgReportService } from './report.service';

export default {
  name: 'JxxfPgReportList',
  components: { ReportPreviewButton },
  data () {
    return {
      loading: false,
      filter: { xmmc: '', bgzt: '', yxzt: '' },
      appliedFilter: {},
      page: { rows: [], total: 0, pageNo: 0, pageSize: 15 }
    };
  },
  computed: {
    pendingGeneration () {
      return this.$route.name === 'jxxfPgdsc';
    },
    columns () {
      if (this.pendingGeneration) {
        return [
          { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
          { key: 'xmmc', slotName: 'xmmc', label: '项目名称', minWidth: '220', align: 'left', type: 'text' },
          { key: 'wtdw', label: '委托单位', minWidth: '200', align: 'left', type: 'text' },
          { key: 'xmbh', label: '项目编号', minWidth: '160', align: 'left', type: 'text' },
          { key: 'jhjsrq', label: '计划结束日期', width: '130', align: 'center', type: 'date' },
          { key: 'wtsl', label: '问题数', width: '90', align: 'center', type: 'text' }
        ];
      }
      return [
        { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', minWidth: '190', align: 'left', type: 'text' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', minWidth: '220', align: 'left', type: 'text' },
        { key: 'wtdwmc', label: '委托单位', minWidth: '200', align: 'left', type: 'text' },
        { key: 'bbh', label: '版本', width: '75', align: 'center', type: 'text' },
        { key: 'bgzt', slotName: 'status', label: '状态', width: '100', align: 'center', type: 'text' },
        { key: 'bgrq', label: '报告日期', width: '120', align: 'center', type: 'date' },
        { key: 'scsbxx', label: '生成失败原因', minWidth: '180', align: 'left', type: 'text' },
        { key: 'zfyy', label: '失效原因', minWidth: '180', align: 'left', type: 'text' }
      ];
    },
    routeStatus () {
      return {
        jxxfPgdqz: { bgzt: 'DQZ', yxzt: 'Y' },
        jxxfPgyqz: { bgzt: 'YWC', yxzt: 'Y' }
      }[this.$route.name] || {};
    }
  },
  methods: {
    refreshSearch () {
      this.appliedFilter = Object.assign({}, this.filter);
      this.search(1);
    },
    search (pageNo = 1) {
      const params = Object.assign({}, this.appliedFilter, this.routeStatus, {
        xmId: this.$route.query.xmId || undefined,
        pageNo,
        pageSize: this.page.pageSize
      });
      this.loading = true;
      const request = this.pendingGeneration
        ? pgxmManageService.query(Object.assign(params, { xmzt: 'DSC' }))
        : pgReportService.page(params);
      request.then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    changePageSize (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    handleReportGenerated () {
      // 当前项目从待生成结果中移出，回到第一页避免末页被移空后停留在无效页码。
      this.search(1);
    },
    resetForm () {
      this.$refs.filterForm.resetFields();
      this.refreshSearch();
    },
    statusText (row) {
      if (row.bgztMc) return row.bgztMc;
      return { SCZ: '生成中', CG: '生成成功', SB: '生成失败' }[row.sczt] || row.sczt || '-';
    },
    downloadPreferred (row) {
      this.loading = true;
      pgReportService.download(row.bgId, row.yqzWjId ? 'YQZ' : 'DZ').then(rsp => {
        const url = URL.createObjectURL(new Blob([rsp.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      }).finally(() => {
        this.loading = false;
      });
    },
    reevaluate (row) {
      Promise.all([
        pgxmManageService.getDetail(row.xmId),
        this.$prompt('重新评估会使当前报告失效并保留历史，请填写原因。', '重新评估', {
          inputType: 'textarea',
          inputPattern: /\S+/,
          inputErrorMessage: '重新评估原因不能为空',
          confirmButtonText: '确认重新评估'
        })
      ]).then(([projectRsp, promptResult]) => pgReportService.reevaluate(row.xmId, {
        reason: promptResult.value,
        lockVersion: projectRsp.data.lockVersion
      })).then(() => {
        this.$message.success('项目已恢复为执行中，请进入项目编辑页继续评估');
        this.closeNavTabAndTo({
          name: 'jxxfPgxmEdit',
          params: { id: row.xmId }
        }, true);
      });
    }
  },
  watch: {
    '$route.name' () {
      this.filter = { xmmc: '', bgzt: '', yxzt: '' };
      this.refreshSearch();
    },
    '$route.query.xmId' () {
      this.refreshSearch();
    }
  },
  created () {
    this.refreshSearch();
  }
};
</script>
